import React, { useState, useEffect } from "react";
import { Parallax } from "react-scroll-parallax";

const Clients = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const clients = [
    {
      name: "AGS Entertainment",
      logo: "/images/clients/ags.svg",
      size: "normal",
    },
    { name: "AVR", logo: "/images/clients/avr.svg", size: "normal" },
    { name: "Vijay TV", logo: "/images/clients/vijay.svg", size: "normal" },
    {
      name: "JioHotstar",
      logo: "/images/clients/jiohotstar.svg",
      size: "large",
    },
    {
      name: "Studio Green",
      logo: "/images/clients/studiogreen.svg",
      size: "normal",
    },
    {
      name: "StartupTN",
      logo: "/images/clients/startuptn.svg",
      size: "normal",
    },
  ];

  const getSpeed = (desktopSpeed) =>
    isMobile ? desktopSpeed * 0.4 : desktopSpeed;

  const firstRowSpeeds = [-8, 5, -12, 8];
  const secondRowSpeeds = [-10, 10];

  return (
    <section
      className="relative px-4 sm:px-6 lg:px-8 overflow-hidden scroll-mt-0"
      style={{
        paddingTop: "clamp(6rem, 15vw, 12rem)",
        paddingBottom: "clamp(8rem, 18vw, 15rem)",
        scrollBehavior: "smooth",
      }}
    >
      {/* Left Glow Effect */}
      <Parallax
        speed={getSpeed(-30)}
        disabled={false}
        className="absolute pointer-events-none"
        style={{
          left: "clamp(-400px, -30vw, -200px)",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        <div
          style={{
            width: "clamp(300px, 50vw, 600px)",
            height: "clamp(400px, 60vw, 800px)",
            background:
              "radial-gradient(circle, rgba(6, 182, 212, 0.3) 0%, rgba(6, 182, 212, 0.15) 40%, transparent 70%)",
            filter: "blur(30px)",
            opacity: 1.2,
          }}
        ></div>
      </Parallax>

      {/* Right Glow Effect */}
      <Parallax
        speed={getSpeed(30)}
        disabled={false}
        className="absolute pointer-events-none"
        style={{
          right: "clamp(-400px, -30vw, -200px)",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        <div
          style={{
            width: "clamp(300px, 50vw, 600px)",
            height: "clamp(400px, 60vw, 800px)",
            background:
              "radial-gradient(circle, rgba(20, 184, 166, 0.15) 0%, rgba(20, 184, 166, 0.08) 40%, transparent 70%)",
            filter: "blur(10px)",
            opacity: 1.2,
          }}
        ></div>
      </Parallax>

      <Parallax
        speed={getSpeed(20)}
        disabled={false}
        className="absolute pointer-events-none"
        style={{ left: "20%", top: "30%" }}
      >
        <div
          style={{
            width: "clamp(100px, 20vw, 200px)",
            height: "clamp(100px, 20vw, 200px)",
            background:
              "radial-gradient(circle, rgba(6, 182, 212, 0.1) 0%, transparent 70%)",
            borderRadius: "50%",
            filter: "blur(40px)",
          }}
        ></div>
      </Parallax>

      {/* Content Container */}
      <div className="w-full max-w-[1920px] mx-auto">
        <div className="px-0 sm:px-4 lg:px-8 xl:px-16">
          {/* Section Title */}
          <div className="text-left mb-8 sm:mb-12 md:mb-20">
            <Parallax
              speed={getSpeed(8)}
              disabled={false}
              translateY={isMobile ? [0, -8] : [10, -10]}
            >
              <h2
                className="font-normal mb-4 sm:mb-6 md:mb-8 bg-gradient-to-r from-[#009999] via-white to-white bg-clip-text text-transparent"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: "clamp(2rem, 5vw, 4rem)",
                  lineHeight: "1.2",
                  letterSpacing: "0.08em",
                }}
              >
                Our Clients
              </h2>
            </Parallax>

            <Parallax
              speed={getSpeed(12)}
              disabled={false}
              translateY={isMobile ? [-8, 8] : [-15, 15]}
            >
              <p
                className="text-gray-400"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: "clamp(14px, 2vw, 20px)",
                  lineHeight: "1.2",
                  letterSpacing: "0.08em",
                }}
              >
                Proud to collaborate with forward thinking brands
              </p>
            </Parallax>
          </div>

          {/* Client Logos */}
          <div className="relative z-10 max-w-6xl mx-auto">
            <div className="space-y-6 sm:space-y-8 md:space-y-12">
              {/* First Row */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 md:gap-12 lg:gap-16 items-center justify-items-center">
                {clients.slice(0, 4).map((client, index) => (
                  <Parallax
                    key={index}
                    speed={getSpeed(firstRowSpeeds[index])}
                    translateY={
                      isMobile
                        ? [6, -6]
                        : index % 2 === 0
                        ? [20, -20]
                        : [-20, 20]
                    }
                    disabled={false}
                  >
                    <div className="w-full flex items-center justify-center p-3 sm:p-4 transition-transform hover:scale-110 duration-300">
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="h-auto object-contain opacity-90 hover:opacity-100 transition-opacity max-w-full"
                        style={{
                          maxWidth:
                            client.size === "large"
                              ? "clamp(120px, 25vw, 280px)"
                              : "clamp(80px, 18vw, 180px)",
                          width: "auto",
                          height: "auto",
                        }}
                      />
                    </div>
                  </Parallax>
                ))}
              </div>

              {/* Second Row */}
              <div className="flex items-center justify-center gap-6 sm:gap-8 md:gap-12 lg:gap-16 flex-wrap">
                {clients.slice(4, 6).map((client, index) => (
                  <Parallax
                    key={index}
                    speed={getSpeed(secondRowSpeeds[index])}
                    translateY={
                      isMobile ? [6, -6] : index === 0 ? [25, -25] : [-25, 25]
                    }
                    disabled={false}
                  >
                    <div className="flex items-center justify-center p-3 sm:p-4 transition-transform hover:scale-110 duration-300 flex-1 min-w-0">
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="h-auto object-contain opacity-90 hover:opacity-100 transition-opacity max-w-full mx-auto"
                        style={{
                          maxWidth: "clamp(80px, 18vw, 180px)",
                          width: "auto",
                          height: "auto",
                        }}
                      />
                    </div>
                  </Parallax>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
